"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'Verification',
  data() {
    return {
      currentStep: 1,
      frontUploaded: false,
      backUploaded: false,
      selfieUploaded: false,
      videoUploaded: false
    };
  },
  methods: {
    simulateUpload(type) {
      if (type === 'front') this.frontUploaded = true;
      if (type === 'back') this.backUploaded = true;
      if (type === 'selfie') this.selfieUploaded = true;
      if (type === 'video') this.videoUploaded = true;
    },
    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++;
      } else {
        alert('¡Toda la documentación ha sido enviada para revisión! Pronto recibirás una notificación.');
      }
    }
  }
};